import axios from 'axios';

const TIME_IN_MINUTE = 10 * 60 * 1000; // 10 minutes

const BASE_URL = process.env.VUE_APP_BASE_URL_THOTH_V2;
const API_KEY = process.env.VUE_APP_API_KEY_THOTH_V2;

const api = axios.create({
    baseURL: BASE_URL,

    headers: {
        'api_key': API_KEY,
    },
    timeout: 0,
});

export default api;
